module.exports = __webpack_public_path__ + "img/iconImg2.7f8aae4b.png";